// extracted by mini-css-extract-plugin
export default {"itemContainer":"Feature_itemContainer__Ps6im","iconContainer":"Feature_iconContainer__s2rdm","textContainer":"Feature_textContainer__sDhNS","svgIcon":"Feature_svgIcon__6QL0A"};